import { activate_counter } from "./counter";

activate_counter();
